import { createReducer } from '@reduxjs/toolkit';
import { IPubnubState } from 'store/types/states';

import { setNamespace, setNotification, setPubNubAuth } from 'store/actions/pubnubActions';

export const INITIAL_STATE: IPubnubState = {
  authorizedUuid: null,
  channelsWithPermissionsList: null,
  expiresOn: null,
  pubNubToken: null,
  namespace: null,
  notification: null,
};

const pubnubReducer = createReducer(INITIAL_STATE, (builder) => {
  builder.addCase(setNamespace, (state, action) => {
    state.namespace = action.payload;
  });
  builder.addCase(setNotification, (state, action) => {
    state.notification = action.payload;
  });
  builder.addCase(setPubNubAuth, (state, action) => {
    const {
      authToken = null,
      authorizedUuid = null,
      channelsWithPermissionsList = null,
      expiresOn = null,
    } = action.payload || {};
    state.pubNubToken = authToken;
    state.authorizedUuid = authorizedUuid;
    state.channelsWithPermissionsList = channelsWithPermissionsList;
    state.expiresOn = expiresOn;
  });
});

export default pubnubReducer;
